package com.eladfinish.bible.contest.di

import org.koin.core.component.KoinComponent
import org.koin.core.component.inject
import org.koin.core.parameter.parametersOf

inline fun <reified T> getKoinInstance() =
    object : KoinComponent {
        val value: T by inject()
    }.value

inline fun <reified T> getKoinInstance(vararg parameters: Any?) =
    object : KoinComponent {
        val value: T by inject { parametersOf(*parameters) }
    }.value